import { Navigate, useParams } from 'react-router-dom'

/**
 * Deep link /links/:linkId opens the manage modal on the Links page.
 */
export default function LinksManageRedirect() {
  const { linkId } = useParams<{ linkId: string }>()
  return <Navigate to="/links" replace state={{ openLinkId: linkId }} />
}
